import { OnInit, OnDestroy, Injectable } from '@angular/core';
import { EventManager } from '../../../../src/app/core';
import { Subject, Subscription } from 'rxjs';
import { QueryParams } from 'src/app/shared/model/query.params.model';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ConfirmPopUpComponent } from 'src/app/shared/components/confirm-popup/confirm-popup.component';
import { debounceTime } from 'rxjs/operators';
import { SubscriptionService } from '../services/subscription.service';

@Injectable({ providedIn: 'any' })
export abstract class ManageComponent implements OnInit, OnDestroy {
  currentAccount: any | null = null;
  subscriptions?: Subscription[] = [];
  list?: any[];
  params: any = {};
  queryParams: QueryParams;
  searchParams: any;
  selectedItem: any;
  deleteBoardcast: string;
  isCalling: boolean = false;
  callApi$ = new Subject();
  subscribeState: any;
  constructor(
    public eventManager: EventManager,
    public modalService: NzModalService
  ) {

  }
  ngOnInit() {
    this.subscribeState = SubscriptionService.register(2, this.parseData.bind(this));
    this.subscriptions = [...[
      this.eventManager.subscribe('load-page', (res) => {
        this.loadPage((res.content || {}).page || 1);
      }),
      this.eventManager.subscribe("change-filter-start-end-date", (res) => {
        this.executeCallAPI();
      }),
      this.callApi$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.callAPI(event);})
    ]];
    this.defaultParams();
  }
  parseData() {}
  callAPI(event?) {
    this.loadAll();
  }
  executeCallAPI(event?) {
    this.callApi$.next(event || true);
  }
  createBoardCastDelete(deleteBoardcast) {
    this.deleteBoardcast = deleteBoardcast;
    this.subscriptions.push(
      this.eventManager.subscribe(deleteBoardcast, (res) => {
        this.delete();
      })
    );
  }
  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.eventManager.destroys(this.subscriptions);
    }
  }
  defaultParams() {
    this.list = [];
    this.queryParams = new QueryParams();
    this.searchParams = {};
  }
  trackId(index: number, item: any): number {
    return (item || {}).id;
  }
  changePageSize(event: number) {
    this.queryParams.page = 1;
    this.queryParams.size = event;
    this.queryParams.pageSize = event;
    this.executeCallAPI();
  }
  loadPage(event: number) {
    const page = event;
    this.queryParams.page = page;
    if (page !== this.queryParams.previousPage) {
      this.queryParams.previousPage = page;
    }
    this.executeCallAPI();
  }
  loadAll(req?: any) {}
  onResponse(next, err) {
    this.eventManager.broadcast({
      name: 'close-spinner',
      content: {}
    });
    if (next) {
      this.onSuccess(next);
    }
    if (!next) {
      this.onNull(next);
    }
    if (err) {
      this.onError(err);
    }
  }
  onNull(response) {
  }
  onSuccess(response) {
    this.isCalling = false;
    const res = (response.body || {}).data || response.data || response;
    if (!res) {
      this.queryParams.totalItems = 0;
      return false;
    }
    this.queryParams.totalItems = res.total;
    this.list = res.list || [];
    this.afterSuccess(response);
    return true;
  }
  afterSuccess(response?) {}
  onError(error) {
    this.isCalling = false;
    this.queryParams.totalItems = 0;
  }
  sort() {
    const result = [this.queryParams.predicate + ',' + (this.queryParams.ascending ? 'asc' : 'desc')];
    if (this.queryParams.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }
  sortField(field, direction?) {
    this.queryParams.sortField = field;
    this.queryParams.sortOrder = direction || 'DESC';
    this.executeCallAPI();
  }
  search(event) {
    this.eventManager.broadcast({
      name: 'get-value-search',
      content: {}
    });
  }
  getValueSearch(event) {
    Object.keys(event).forEach((key) => {
      this.queryParams.searchParams[key] =  event[key];
    });
    const keys = Object.keys(this.queryParams.searchParams);
    keys.forEach((key) => {
      if (typeof this.queryParams.searchParams[key] === 'string') {
        this.queryParams.searchParams[key] = this.queryParams.searchParams[key].trim();
        if (this.queryParams.searchParams[key] === 'undefined' || this.queryParams.searchParams[key] === '') {
          this.queryParams.searchParams[key] = undefined;
        }
      }
    });
    this.loadPage(1);
  }
  checkChangeSearchParams() {
    this.searchParams = this.searchParams || {};
    const  isChange = Object.keys(this.queryParams.searchParams).some((property) => {
      return this.queryParams.searchParams[property] !== this.searchParams[property] && property !== 'page';
    })
    if (isChange) {
      this.queryParams.page = 1;
      this.searchParams = Object.assign({}, this.queryParams.searchParams);
    }
    return this.queryParams;
  }
  eventSearchParams(key, value) {
    this.eventManager.broadcast({
      name: 'add-option-search',
      content: {
        key, value
      }
    });
  }
  delete() {
  }
  confirmDelete(selectedItem, title?) {
    this.selectedItem = selectedItem;
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzContent: ConfirmPopUpComponent,
      nzData: {
        eventBroadcast: this.deleteBoardcast,
        title
      },
      nzOnOk: (() => { this.delete() })
    });
  }
  confirmAction(selectedItem, title?, fowardFunc?) {
    this.selectedItem = selectedItem;
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzContent: ConfirmPopUpComponent,
      nzData: {
        title
      },
      nzOnOk: (() => { fowardFunc() })
    });
  }
}
